<button
  *ngIf="(debugLoggingEnabled$ | async) === false"
  mat-icon-button
  type="button"
  matTooltip="Start debug logging"
  (click)="startDebugLogging()"
>
  <mat-icon svgIcon="start-debug-logging"></mat-icon>
</button>

<button
  *ngIf="debugLoggingEnabled$ | async"
  mat-icon-button
  type="button"
  matTooltip="Flag technical issue"
  (click)="flagTechnicalIssue()"
>
  <mat-icon svgIcon="flag-technical-issue"></mat-icon>
</button>
